import { chartNames, } from "../../consts";
import { rumEventsUtil } from "../../utils";

// Browser and OS Usage
// _________________________________________________________________________

const getDeviceConnectionsCountByBrowser = (data, devices) => {
  const metricsConfig = rumEventsUtil.getMetricsConfig({
    chartName: chartNames.BROWSER
  });

  const chartData = rumEventsUtil.prepareChartData({
    data,
    devices,
    groupFn: (event) => {
      return event.metadata?.browserName
    }
  });

  if (!chartData?.grouped || !metricsConfig) {
    return [];
  }

  const { grouped } = chartData;
  let result = [];
  let totalDeviceConnectionsCount = 0;
  grouped.size > 0 &&
    grouped.forEach((events) => {
      let count = 0;

      const browserCounts = {
        "Chrome": 0,
        "Edge": 0,
        "Safari": 0,
        "Firefox": 0,
        "Opera": 0,
        "Bluefy": 0,
        "Other": 0,
      };

      events.forEach((event) => {
        const browserName = event?.metadata?.browserName;

        if (browserName in browserCounts) {
          browserCounts[browserName]++;
        } else {
          browserCounts['Other']++;
        }
      });

      if (events && events?.length > 0) {
        count = events?.length;
      }

      totalDeviceConnectionsCount += count;

      result.push({
        metrics: {
          "Google Chrome": browserCounts["Chrome"],
          "Microsoft Edge": browserCounts["Edge"],
          "Safari": browserCounts["Safari"],
          "Mozilla Firefox": browserCounts["Firefox"],
          "Opera": browserCounts["Opera"],
          "Bluefy": browserCounts["Bluefy"],
          'Other': browserCounts["Other"],
        }
      });
    });

  return { result, totalDeviceConnectionsCount };
};


const getDeviceConnectionsCountByOS = (data, devices) => {
  const metricsConfig = rumEventsUtil.getMetricsConfig({
    chartName: chartNames.OS
  });

  const chartData = rumEventsUtil.prepareChartData({
    data,
    devices,
    groupFn: (event) => {
      return event.metadata?.osName
    }
  });

  if (!chartData?.grouped || !metricsConfig) {
    return [];
  }

  const { grouped } = chartData;
  let result = [];
  let totalDeviceConnectionsCount = 0;

  grouped.size > 0 &&
    grouped.forEach((events) => {
      let count = 0;

      const osCounts = {
        "Windows": 0,
        "Android": 0,
        "Linux": 0,
        "Mac OS": 0,
        "iOS": 0,
        "Other": 0,
      };

      events.forEach((event) => {
        const osName = event?.metadata?.osName;

        if (osName in osCounts) {
          osCounts[osName]++;
        } else {
          osCounts["Other"]++;
        }
      });

      if (events && events?.length > 0) {
        count = events?.length;
      }

      totalDeviceConnectionsCount += count;

      result.push({
        metrics: {
          Windows: osCounts["Windows"],
          Android: osCounts["Android"],
          Linux: osCounts["Linux"],
          macOS: osCounts["Mac OS"],
          iOS: osCounts["iOS"],
          Other: osCounts["Other"]
        }
      });
    });

  return { result, totalDeviceConnectionsCount };
};

const browserAndOSUtil = {
  // Browser and OS Usage
  // _________________________________________________________________________
  getDeviceConnectionsCountByBrowser,
  getDeviceConnectionsCountByOS,
};

export default browserAndOSUtil;
